module.exports = __webpack_public_path__ + "img/symbol_0.44e4714f.png";